import { Fields } from '@measured/puck';

export const heightOptions = [
  { label: '0', value: 'h-0' },
  { label: '1', value: 'h-1' },
  { label: '2', value: 'h-2' },
  { label: '4', value: 'h-4' },
  { label: '6', value: 'h-6' },
  { label: '8', value: 'h-8' },
  { label: '10', value: 'h-10' },
  { label: '12', value: 'h-12' },
  { label: '14', value: 'h-14' },
  { label: '16', value: 'h-16' },
  { label: '20', value: 'h-20' },
  { label: '24', value: 'h-24' },
  { label: '28', value: 'h-28' },
  { label: '32', value: 'h-32' },
  { label: '36', value: 'h-36' },
  { label: '40', value: 'h-40' },
  { label: 'full', value: 'h-full' },
  { label: 'auto', value: 'h-auto' },
];

export const textAlignOption = [
  { label: 'Left', value: 'left' },
  { label: 'Center', value: 'center' },
  { label: 'Right', value: 'right' },
  { label: 'Justify', value: 'justify' },
];

export const placeHolderHeightOptions = [
  { label: '0', value: '0' },
  { label: '0.5', value: '0.5' },
  { label: '1', value: '1' },
  { label: '1.5', value: '1.5' },
  { label: '2', value: '2' },
  { label: '2.5', value: '2.5' },
  { label: '3', value: '3' },
  { label: '3.5', value: '3.5' },
  { label: '4', value: '4' },
  { label: '4.5', value: '4.5' },
  { label: '5', value: '5' },
  { label: '5.5', value: '5.5' },
  { label: '6', value: '6' },
  { label: '6.5', value: '6.5' },
  { label: '7', value: '7' },
  { label: '7.5', value: '7.5' },
  { label: '8', value: '8' },
  { label: '8.5', value: '8.5' },
  { label: '9', value: '9' },
  { label: '9.5', value: '9.5' },
  { label: '10', value: '10' },
  { label: 'full', value: 'full' },
  { label: 'auto', value: 'auto' },
];

export type HeightProps = {
  height: string;
};

export const heightField: Fields<HeightProps> = {
  height: {
    type: 'select',
    label: 'Height',
    options: heightOptions,
  },
};
